import api from "../../../../service/api";

export const uploadBankTransaction = async (formData) => {
    const response = await api.post(
        "tms/bank-transaction/upload",
        formData
    );

    return response.data;
};

export const fetchUnpaidInvoices = async (search = {}) => {
    const response = await api.get(
        "tms/bank-transaction",
        search
    );

    return response;
};
